import { useCallback, useMemo } from 'react';
import { RadioList, RadioListItem } from '@salecycle/ui-component-library';
import { ControlCard } from 'sections/onsite-campaigns/pages/CampaignEditor/components/ControlCard';
import { useTrigger } from '../../hooks/useTrigger';
import { useWorkflowForm } from '../../../../../contexts/CampaignWorkflowFormContext';
import { useTranslation } from 'react-i18next';

export const FrequencyConfiguration = () => {
  const { getFrequency, setFrequency } = useTrigger();
  const { formDisabled } = useWorkflowForm();
  const { t } = useTranslation('campaigns');

  const setFrequencyHandler = useCallback(
    frequency => {
      setFrequency({ frequency });
    },
    [setFrequency],
  );

  const selectedFrequency = useMemo(() => getFrequency(), [getFrequency]);

  const frequencyOptions = [
    { id: 'everyVisit', value: 'not set' },
    { id: 'daily', value: 'daily' },
    { id: 'weekly', value: 'weekly' },
    { id: 'monthly', value: 'monthly' },
    { id: 'yearly', value: 'yearly' },
  ];

  return (
    <ControlCard>
      <RadioList
        caption={t('onsite.frequency.caption')}
        compacted
        tooltip
        tooltipHtml={
          <div style={{ padding: '1rem' }}>
            <h4 style={{ marginBottom: '8px' }}>{t(`onsite.frequency.tooltipHeading`)}</h4>
            <p style={{ fontSize: '14px' }}>{t(`onsite.frequency.tooltipDescription`)}</p>
          </div>
        }
      >
        {frequencyOptions.map(({ id, value }) => (
          <RadioListItem
            key={id}
            id={t(`onsite.frequency.${id}.id`)}
            aria-label={t(`onsite.frequency.${id}.ariaLabel`)}
            heading={t(`onsite.frequency.${id}.heading`)}
            selected={selectedFrequency === value}
            onClick={() => setFrequencyHandler(value)}
            disabled={formDisabled}
          />
        ))}
      </RadioList>
    </ControlCard>
  );
};
